<!--PopupVideo:视频播放蒙层 2021/12/22 10:54:10 YuAng-->
<template>
  <van-popup v-model="video.visible" style="background: black" @close="closePopup">
    <template v-if="video.visible">
      <p v-if="video.title" class="video-title">{{video.title}}</p>
      <video width="375px" autoplay :src="video.url" controls="controls">
        抱歉，你的设备浏览器不支持视频播放！
      </video>
    </template>
  </van-popup>
</template>
<script>
export default {
  name: 'PopupVideo',
  props: {
    video: {
      type: Object,
      default: function () {
        return {
          visible: false,
          url: ''
        }
      }
    }
  },
  methods: {
    closePopup: function () {
      const videos = document.getElementsByTagName('video')
      for (let index = 0; index < videos.length; index++) {
        const element = videos[index];
        element.pause()
      }
    }
  }
}
</script>

<style scoped>
.video-title {
  color: white;
  padding: 8px;
  text-align: center;
  margin: 0 !important;
}
</style>